import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["count"];
import React, { memo } from 'react';
import Text from '../../../typography/Text';
var PostComponent = function PostComponent(_ref) {
  var count = _ref.count,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Text, props, "+", count);
};
export default /*#__PURE__*/memo(PostComponent);